import React from 'react'
import {Icon} from '@chakra-ui/react'

const HideIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" {...props}>
            <path
                d="M20.0627 28.8606C15.2057 28.8606 11.2471 24.9113 11.2471 20.0449C11.2471 15.1785 15.1963 11.2293 20.0627 11.2293C24.9291 11.2293 28.8784 15.1785 28.8784 20.0449C28.8784 24.9113 24.9291 28.8606 20.0627 28.8606ZM20.0627 13.101C16.2351 13.101 13.1188 16.2173 13.1188 20.0449C13.1188 23.8725 16.2351 26.9889 20.0627 26.9889C23.8903 26.9889 27.0067 23.8725 27.0067 20.0449C27.0067 16.2173 23.8903 13.101 20.0627 13.101Z"
                fill="currentColor"
            />
            <path
                d="M19.7819 31.9863C9.50636 31.9863 1.77627 21.0837 1.44873 20.6158C1.32707 20.4474 1.28027 20.2508 1.28027 20.0637C1.28027 19.8671 1.33642 19.6706 1.45808 19.5022C1.78563 19.0342 9.69353 8.14099 20.0627 8.14099C31.5081 8.14099 38.1526 19.1091 38.4333 19.5677C38.5176 19.708 38.5644 19.8765 38.5644 20.0449C38.5644 20.2134 38.5176 20.4286 38.424 20.5784C38.1339 21.0463 31.1525 31.9863 19.7913 31.9863H19.7819ZM3.37657 20.073C5.03301 22.2067 11.7056 30.124 19.7819 30.124C28.8316 30.124 35.0737 22.0944 36.5149 20.0543C35.1298 18.0048 29.1497 10.0127 20.0627 10.0127C11.8834 10.0127 5.06109 17.9486 3.37657 20.073Z"
                fill="currentColor"
            />
            <path
                d="M38.0682 39.0707C37.8249 39.0707 37.591 38.9771 37.4038 38.7993L1.27081 2.60078C0.905825 2.2358 0.905825 1.64622 1.27081 1.28124C1.63578 0.916262 2.22537 0.916262 2.59035 1.28124L38.7233 37.4797C39.0883 37.8447 39.0883 38.4343 38.7233 38.7993C38.5362 38.9771 38.3022 39.0707 38.0589 39.0707H38.0682Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default HideIcon
